import { DialogActions, DialogContent, Grid } from "@mui/material";

import React from "react";
import gql from "graphql-tag";
import { useMutation } from "react-apollo";

import { toast } from "react-toastify";

import { DeleteCdnSecurityJwtKey, DeleteCdnSecurityJwtKeyVariables } from "./__generated__/DeleteCdnSecurityJwtKey";
import { GET_CHANNEL_QUERY } from "../Overview/channelQueriesMutations";
import { TOAST_SETTINGS } from "../../BillingDetails/AddPaymentMethodDialog";
import DialogHESP from "../../DialogHESP/DialogHESP";
import DialogFooterWithLoading from "../../Loading/DialogFooterWithLoading";

interface Props {
    open: boolean;
    keyId: string;
    aliasId: string;
    channelId: string;
    organizationId: string;
    onClose: () => void;
}

export const DELETE_CDN_SECURITY_KEY = gql`
    mutation DeleteCdnSecurityJwtKey($input: RemoveCdnSecurityJwtKey!) {
        deleteCdnSecurityJwtKey(input: $input)
    }
`;

export default function DeleteCdnJwtKeyDialog({ onClose, open, keyId, aliasId, channelId, organizationId }: Props) {
    const [deleteJwtKey, { loading }] = useMutation<DeleteCdnSecurityJwtKey, DeleteCdnSecurityJwtKeyVariables>(
        DELETE_CDN_SECURITY_KEY,
    );

    async function onConfirm() {
        try {
            await deleteJwtKey({
                variables: {
                    input: {
                        aliasId,
                        channelId,
                        keyId,
                        organizationId,
                    },
                },
                refetchQueries: [
                    {
                        query: GET_CHANNEL_QUERY,
                        variables: {
                            channelId,
                            organizationId,
                        },
                    },
                ],
            });
            toast.success("Key successfully removed");
            onClose();
        } catch (e) {
            toast.error("Unknown error", TOAST_SETTINGS);
        }
    }

    return (
        <DialogHESP
            title={"Remove JWT key"}
            open={open}
            onClose={onClose}
            content={
                <>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} style={{ marginTop: "14px" }}>
                                Are you sure you want to remove this key?
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <DialogFooterWithLoading
                            isLoading={loading}
                            onCancelClick={onClose}
                            onActionClick={onConfirm}
                            defaultText={"Remove"}
                            loadingText={"Removing..."}
                        />
                    </DialogActions>
                </>
            }
        />
    );
}
